import React, { Component } from 'react';
import '../../inc/genstyle.css';
import DateTimeFormats from '../../inc/date-time-format';
import ReplaceAllContent from '../../inc/replace-all';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SearchIcon from '@mui/icons-material/Search';

class ZTELogDetail extends Component {
    constructor (props) {
        super(props);
        this.state = {
            stPopTitle: '',
            postType: '',
            createDate: '',
            createBy: '',
            domainName: '',
            requestList: {},
            preprovToken: '',
            fileId: '',
            keyword: '',
            styleTb: 'table',
            data: [],
            data_all: [],
            linkUrl: '',
            actiontype: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        var value =  e.target.value;
        var resultData = this.state.data_all.filter((list) =>  {
            return (list.preProvisionedDevice.serialNumber?.toLowerCase().includes(value.toLowerCase()) || list.serialNumber?.toLowerCase().includes(value.toLowerCase()));
        });
        this.setState({ 
            keyword : value,
            data: resultData
        })
      }
    urlopenFile(ln) {
        window.open(ln);
    }
    urlDownloadCSV() {
        var datenows = new Date();
        var title_file = "["+this.state.domainName+"]_"+datenows.getFullYear()+("0"+(datenows.getMonth()+1)).slice(-2)+("0"+(datenows.getDate())).slice(-2);
        
        var strData = "Domain, Pre-provisioning Token, Created on, PreProvision Device Id, Serial Number, AD ID, Hardware Model, Brand Code, Provision Id, Status, Remarks, Return Code";
        this.state.data.forEach((item) => {

            strData += "\n";
            strData += this.state.domainName+",";
            strData += this.state.preprovToken+",";
            strData += this.state.createDate+",";
            strData += (item.preProvisionedDevice.preProvisionedDeviceId !== undefined? ReplaceAllContent(',',';',item.preProvisionedDevice.preProvisionedDeviceId) : "")+",";
            strData += (item.preProvisionedDevice.serialNumber !== undefined? ReplaceAllContent(',',';',item.preProvisionedDevice.serialNumber) : "") + ",";
            strData += (item.preProvisionedDevice.attestedDeviceId !== undefined? ReplaceAllContent(',',';',item.preProvisionedDevice.attestedDeviceId) : "") +",";
            strData += (item.preProvisionedDevice.hardwareModel !== undefined? ReplaceAllContent(',',';',item.preProvisionedDevice.hardwareModel) : "") +",";
            strData += (item.preProvisionedDevice.brandCode !== undefined? ReplaceAllContent(',',';',item.preProvisionedDevice.brandCode) : "") +",";
            strData += (item.preProvisionedDevice.preProvisionerId !== undefined?  ReplaceAllContent(',',';',item.preProvisionedDevice.preProvisionerId) : "") +",";
            strData += (item.preProvisionedDevice.deviceState !== undefined? ReplaceAllContent(',',';',item.preProvisionedDevice.deviceState) : "") +",";
            strData += (item.preProvisionedDevice.errMessage !== undefined? ReplaceAllContent(',',';',ReplaceAllContent('\n',' ~ ',item.preProvisionedDevice.errMessage)) : "") +",";
            strData += (item.preProvisionedDevice.errCode !== undefined? ReplaceAllContent(',',';',item.preProvisionedDevice.errCode) : "");
        })
        
        
        const jsonData = new Blob([strData], { type: 'text/csv' });
        const jsonURL = URL.createObjectURL(jsonData);
        const link = document.createElement('a');
        link.href = jsonURL;
        link.download = title_file+'.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
    }
    componentDidMount() {
        document.getElementById('loading-area').style.display = 'block'; 
        var contents = JSON.parse(document.getElementById("contentoth").innerText);
        
        var othersContent = contents.dataSend;
        var createNamez = "", cDatez = "", domain_name = "", provisioning_token = "", action_type = "", file_id="", post_type="", link_url="";
        var resultData = [];
         if(othersContent.createdate !== undefined) {
              cDatez = DateTimeFormats(othersContent.createdate._seconds,"datetime-long");
         }
         if(othersContent.domainname !== undefined) {
            domain_name = othersContent.domainname;
         } 
         if(othersContent.detail_request.length > 0 && othersContent.detail_request[0].device_pre_provisioning_token !== undefined) {
            provisioning_token = othersContent.detail_request[0].device_pre_provisioning_token;
         }
         if(othersContent.actiontype !== undefined) {
            action_type = othersContent.actiontype;
         }
         if(othersContent.createby !== undefined) {
            createNamez = othersContent.createby;
         }
        
        if(othersContent.fileid !== undefined && othersContent.fileid !== "") {
            post_type = "bulk";
            file_id = othersContent.fileid;
            link_url = 'https://docs.google.com/spreadsheets/d/'+file_id;
            if(action_type === global.config.zteType[1]) { 
                if(othersContent.detail_response !== undefined) {
                    othersContent.detail_response.forEach((dataresponse2) => {
                        if(dataresponse2.error !== undefined) {
                            resultData.push({
                                "status": dataresponse2.error.status,
                                "brandCode": '',
                                "name": '',
                                "serialNumber": '',
                                "preprovision_deviceid": "",
                                "message": dataresponse2.error.message,
                                "code": dataresponse2.error.code
                            })
                            
                        } else if(dataresponse2 !== undefined) {
                            resultData.push({
                                "status": dataresponse2.status,
                                "brandCode": '',
                                "name": '',
                                "serialNumber": dataresponse2.serial_number,
                                "preprovision_deviceid": dataresponse2.preprovision_deviceid,
                                "message": dataresponse2.message,
                                "code": dataresponse2.code
                            })
                        }
                    })
                } else {
                    resultData.push({
                        "status": "Error",
                        "brandCode": '',
                        "name": '',
                        "serialNumber": '',
                        "preprovision_deviceid": "",
                        "message": "NONE",
                        "code": "XXXX"
                    })
                }
            } else {
                if(othersContent.detail_response !== undefined) {
                    othersContent.detail_response.forEach((dataresponse) => {
                        if(dataresponse.error !== undefined) {
                            resultData.push({
                                "preProvisionedDevice": 
                                    {
                                        "preprovision_deviceid": "",
                                        "hardwareModel": "",
                                        "serialNumber": "",
                                        "attestedDeviceId": "",
                                        "deviceState": dataresponse.error.status,
                                        "brandCode": '',
                                        "name": '',
                                        "preProvisionerId": '',
                                        "errMessage": dataresponse.error.message,
                                        "errCode": dataresponse.error.code
                                    }
                                
                            })
                        } else if(dataresponse.values !== undefined) {
                            dataresponse.values.responses.forEach((datainsert) => {
                                resultData.push(datainsert);    
                            })
                           
                        } else if(dataresponse.status !== undefined) {
                            resultData.push({
                                "preProvisionedDevice": 
                                    {
                                        "preprovision_deviceid": "",
                                        "hardwareModel": "",
                                        "serialNumber": "",
                                        "attestedDeviceId": "",
                                        "deviceState": "",
                                        "brandCode": '',
                                        "name": '',
                                        "preProvisionerId": '',
                                        "errMessage": dataresponse.status.message,
                                        "errCode": dataresponse.status.code
                                    }
                                
                            })
                        
                        } else if(dataresponse.preProvisionedDevice !== undefined) {
                            resultData.push(dataresponse);    
                        }
                    })
                    

                    
                } else {
                    resultData.push({
                        "preProvisionedDevice": 
                            {
                                "preprovision_deviceid": "",
                                "hardwareModel": "",
                                "serialNumber": "",
                                "attestedDeviceId": "",
                                "deviceState": "Error",
                                "brandCode": '',
                                "name": '',
                                "preProvisionerId": '',
                                "errMessage": "NONE",
                                "errCode": "XXXX"
                            }
                        
                    })
                }
            }
        } else {
            post_type = "single";
            
            if(action_type === global.config.zteType[1]) { 
                if(othersContent.detail_response !== undefined) {
                    othersContent.detail_response.forEach((dataresponse2b) => {
                        if(dataresponse2b.error !== undefined) {
                            resultData.push({
                                "status": dataresponse2b.error.status,
                                "brandCode": '',
                                "name": '',
                                "serialNumber": '',
                                "preprovision_deviceid": "",
                                "message": dataresponse2b.error.message,
                                "code": dataresponse2b.error.code
                            })
                            
                        } else if(dataresponse2b !== undefined) {
                            resultData.push({
                                "status": dataresponse2b.status,
                                "brandCode": '',
                                "name": '',
                                "serialNumber": dataresponse2b.serial_number,
                                "preprovision_deviceid": dataresponse2b.preprovision_deviceid,
                                "message": dataresponse2b.message,
                                "code": dataresponse2b.code
                            })
                        }
                    })
                } else {
                    resultData.push({
                        "status": "Error",
                        "brandCode": '',
                        "name": '',
                        "serialNumber": '',
                        "preprovision_deviceid": "",
                        "message": "NONE",
                        "code": "XXXX"
                    })
                }
                
            } else {
                if(othersContent.detail_response !== undefined) {
                    othersContent.detail_response.forEach((dataresponse1b) => {
                        if(dataresponse1b.error !== undefined) {
                            resultData.push({
                                "preProvisionedDevice": 
                                    {
                                        "preprovision_deviceid": "",
                                        "hardwareModel": "",
                                        "serialNumber": "",
                                        "attestedDeviceId": "",
                                        "deviceState": dataresponse1b.error.status,
                                        "brandCode": '',
                                        "name": '',
                                        "preProvisionerId": '',
                                        "errMessage": dataresponse1b.error.message,
                                        "errCode": dataresponse1b.error.code
                                    }
                                
                            })
                        } else if(dataresponse1b.values !== undefined) {
                            dataresponse1b.values.responses.forEach((datainsert1b) => {
                                resultData.push(datainsert1b);    
                            })
                        } else if(dataresponse1b.status !== undefined) {
                            resultData.push({
                                "preProvisionedDevice": 
                                    {
                                        "preprovision_deviceid": "",
                                        "hardwareModel": "",
                                        "serialNumber": "",
                                        "attestedDeviceId": "",
                                        "deviceState": "",
                                        "brandCode": '',
                                        "name": '',
                                        "preProvisionerId": '',
                                        "errMessage": dataresponse1b.status.message,
                                        "errCode": dataresponse1b.status.code
                                    }
                                
                            })
                        
                        } else if(dataresponse1b.preProvisionedDevice !== undefined) {
                            resultData.push(dataresponse1b);    
                        }
                    })
                    

                    
                } else {
                    resultData.push({
                        "preProvisionedDevice": 
                            {
                                "preprovision_deviceid": "",
                                "hardwareModel": "",
                                "serialNumber": "",
                                "attestedDeviceId": "",
                                "deviceState": "Error",
                                "brandCode": '',
                                "name": '',
                                "preProvisionerId": '',
                                "errMessage": "NONE",
                                "errCode": "XXXX"
                            }
                        
                    })
                }
            }
            
        }
        this.setState({
            postType: post_type,
            createDate: cDatez,
            createBy: createNamez,
            domainName: domain_name,
            requestList: othersContent.detail_request,
            preprovToken: provisioning_token,
            fileId: file_id,
            linkUrl: link_url,
            data: resultData,
            data_all: resultData,
            actiontype: action_type,
            keyword: contents.keyword
        })
        document.getElementById('loading-area').style.display = 'none'; 
    
    }
    contentParentTable() {
        var requestInfoList = [];
        if(this.state.requestList.length > 0) {
            this.state.requestList.forEach((datarequest, ls2) => {
                var link2Url = ""; 
                if(datarequest.fileid !== undefined && datarequest.fileid !== "") {
                    link2Url = 'https://docs.google.com/spreadsheets/d/'+datarequest.fileid;
                }

                requestInfoList.push(<tr key={ls2+1}>
                    <td>{datarequest.device_pre_provisioning_token !== undefined? datarequest.device_pre_provisioning_token : ''}</td>
                    <td>{link2Url !== ""? 
                        <label className="text-wrap text-break cursor-on"  onClick={this.urlopenFile.bind(this, link2Url)}>{link2Url}</label>
                     : ''}</td>
                     <td>{link2Url !== ""? 
                        <OpenInNewIcon className="iconGrey mgR20 cursor-on" onClick={this.urlopenFile.bind(this, link2Url)}/>
                     : ''}</td>
                  </tr>)
            });
        } else {
            requestInfoList.push(<tr key="C0">
              <td colSpan="2" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
            </tr>)
        }
        return requestInfoList;
    }
    contentTableList() {
        var resultList = [];
        if(this.state.data.length > 0) {
            for(var ls=0; ls < this.state.data.length; ls++) {
                var retResult = this.state.data[ls];
                if(this.state.actiontype === global.config.zteType[1]) {
                    resultList.push(<tr key={ls+1}>
                        <th scope="row-field">{ls+1}</th>
                        <td>{retResult.preprovision_deviceid}</td>
                        <td>{retResult.serialNumber}</td>
                        <td>
                            <div>{retResult.status}</div>
                            {(retResult.message !== undefined)? 
                            <div className="font-sublist">{retResult.message}</div>
                            : <div></div> }
                            {(retResult.code !== undefined)? 
                            <div className="font-sublist">( Code : {retResult.code} )</div>
                            : <div></div> }
                        </td>

                    </tr>)
                } else {
                    if(retResult.preProvisionedDevice !== undefined) {
                        resultList.push(<tr key={ls+1}>
                            <th scope="row-field">{ls+1}</th>
                            <td>{retResult.preProvisionedDevice.preProvisionedDeviceId}</td>
                            <td>{retResult.preProvisionedDevice.serialNumber}</td>
                            <td>{retResult.preProvisionedDevice.attestedDeviceId}</td>
                            <td>
                                <div>{retResult.preProvisionedDevice.hardwareModel}</div>
                                {(retResult.preProvisionedDevice.brandCode !== "")? 
                                <div className="mgT05">( Brand : {retResult.preProvisionedDevice.brandCode} )</div>
                                : <div></div> }
                            </td>
                            <td>{retResult.preProvisionedDevice.preProvisionerId}</td>
                            <td>
                                <div>{retResult.preProvisionedDevice.deviceState}</div>
                                {(retResult.preProvisionedDevice.errMessage !== undefined)? 
                                <div className="font-sublist">{retResult.preProvisionedDevice.errMessage}</div>
                                : <div></div> }
                                {(retResult.preProvisionedDevice.errCode !== undefined)? 
                                <div className="font-sublist">( Code : {retResult.preProvisionedDevice.errCode} )</div>
                                : <div></div> }
                            </td>

                        </tr>)
                    } else {
                        resultList.push(<tr key={ls+1}>
                            <th scope="row-field">{ls+1}</th>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <div>{retResult.status.message}</div>
                                <div className="mgT05 font-sublist">Code : {retResult.status.code}</div>
                            </td>

                        </tr>)
                    }
                }
            }
        } else {
            resultList.push(<tr key="0">
                    <td colSpan="6" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
                </tr>)
        }
        return resultList;
      }
    render() {
        
        return (
            <div className="main-container">
                <div className="mgT20">
                    <div className="content-container card card-body">
                        <div className="mgT20" id="detail-info">
                            <div className="flex-container">
                                <div className="w30p">Created on </div>
                                <div className="mgL10"> {this.state.createDate} <span className="mgL30">by.</span><span className="mgL10"> {this.state.createBy}</span></div>
                            </div>
                            {(this.state.actiontype !== "")? 
                            <div className="mgT20 flex-container">
                                <div className="w30p">Type </div>
                                <div className="mgL10"> {this.state.actiontype} </div>
                            </div>
                            : <div></div> }
                            <div className="mgT20 flex-container">
                                <div className="w30p">Domain </div>
                                <div className="mgL10"> {this.state.domainName} </div>
                            </div>
                            {(this.state.requestList !== undefined && this.state.requestList.length > 1)?
                                <div className="mgT20 table-responsive">
                                    <table className="table">
                                        <thead className="thead-light">
                                          <tr>
                                            <th scope="col">Pre-provisioning Token</th>
                                            <th scope="col">Reference Files</th>
                                            <th scope="col" style={{width: "80px"}}></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                            {this.contentParentTable()}
                                        </tbody>
                                    </table>
                                </div>
                            
                            :  
                                <div className="mgT05">
                                    {(this.state.preprovToken !== "")? 
                                    <div className="flex-container">
                                        <div className="w30p">Pre-provisioning Token</div>
                                        <div className="mgL10"> {this.state.preprovToken} </div>
                                    </div>
                                    : <div></div> }
                                    {(this.state.linkUrl !== "")? 
                                    <div className="mgT20 flex-container">
                                        <div className="w30p">Reference Files</div>
                                        <div className="mgL10 w70p" > 
                                            <div className="flex-container">
                                                <div id="fileurl" className="text-wrap text-break cursor-on" onClick={this.urlopenFile.bind(this, this.state.linkUrl)}>{this.state.linkUrl}</div>
                                                <div className="mgL20"><OpenInNewIcon className="iconGrey mgR20 cursor-on" onClick={this.urlopenFile.bind(this, this.state.linkUrl)}/></div>
                                            </div>
                                        </div>
                                    </div>
                                    : <div></div> }
                                </div>
                            }
                        </div>
                        <div className="flex-container mgT20 ">
                            <div className="flex-container w60p">
                                    <input type="text" className="form-control mr-sm-2" 
                                        name="keyword" id="keyword"
                                        placeholder="Search serial number.."
                                        value={this.state.keyword}
                                        onChange={this.handleChange.bind(this)}
                                        ref={(input) => this.textInputKeyword = input}
                                    />
                                    <SearchIcon style={{ fontSize: 35 }} className="iconGrey mgT05 cursor-on" onClick={this.handleChange.bind(this)}></SearchIcon> 
                                
                            </div>
                            <div className="w40p">
                                {
                                    (this.state.actiontype === global.config.zteType[0]) ?
                                        <div className="d-flex justify-content-end" id="detail-info"><button id="downloadcsv-button" className="genButton " onClick={this.urlDownloadCSV.bind(this)}>Download as CSV</button></div>
                                    :   <></>
                                }
                            </div>
                        </div>
                       
                        {(this.state.actiontype === global.config.zteType[1])? 
                        <div className="row-field mgT30">
                            <table className={this.state.styleTb}>
                            <thead className="thead-light">
                                <tr key="0">
                                <th scope="col">#</th>
                                <th scope="col">PreProvision Device Id</th>
                                <th scope="col">Serial Number</th>
                                <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.contentTableList()}
                            </tbody>
                            </table>
                        </div>
                        :
                        <div className="row-field mgT30">
                            <table className={this.state.styleTb}>
                            <thead className="thead-light">
                                <tr key="0">
                                <th scope="col">#</th>
                                <th scope="col">PreProvision Device Id</th>
                                <th scope="col">Serial Number</th>
                                <th scope="col">AD ID</th>
                                <th scope="col">Hardware Model</th>
                                <th scope="col">Provision Id</th>
                                <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.contentTableList()}
                            </tbody>
                            </table>
                        </div>
                        }
                    </div>
                </div>
                <div id="loading-area" className="divHide loading"></div> 
            </div>
        )
    }
}

export default ZTELogDetail;